module.exports = __webpack_public_path__ + "static/media/Q.5e418224.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/Q.jpg
// module id = 85
// module chunks = 0